import envRaw from '../utils/env-raw'

import { signUserFunction } from './gallery-properties.flow'

import {
  isGtZeroInteger,
  toGtZeroInteger
} from '../utils/bits'

import {
  TOP_POSTS_LIMIT_LE,
  TOP_POSTS_LIMIT_DEFAULT
} from '../utils/shared-constants'

export default signUserFunction(calcTopPostsLimit)

function calcTopPostsLimit(rawVal, calcProp) {
  const global_posts_limit = calcProp('global_posts_limit')
  const tempTopLimit = toGtZeroInteger(rawVal)
  const top_posts_limit = isGtZeroInteger(tempTopLimit)
    ? tempTopLimit
    : envRaw.liveEditMode
      ? TOP_POSTS_LIMIT_LE
      : TOP_POSTS_LIMIT_DEFAULT

  if (isGtZeroInteger(global_posts_limit)) {
    return Math.min(top_posts_limit, global_posts_limit)
  } else {
    return top_posts_limit
  }
}
